import type { UserWithLawFirm } from '@common/types/users';
import axiosInstance from '@/services/axiosInstance';

export async function fetchCurrentUser() {
    return axiosInstance.get<UserWithLawFirm>('/api/v1/identities/me');
}
